module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray-18a84645b09ad9b5acf0e3402d81a09f.png";